<template>
    <CDropdown
            inNav
            class="c-header-nav-items"
            placement="bottom-end"
            add-menu-classes="pt-0"
    >
        <template #toggler>
            <CHeaderNavLink>
                <div class="c-avatar">
                    <img
                            src="/img/avatars/custom.png"
                            class="c-avatar-img "
                    />
                </div>
            </CHeaderNavLink>
        </template>
        <CDropdownHeader tag="div" class="text-center" color="light">
            <strong>{{user_name}}</strong>
        </CDropdownHeader>

<!--        <CDropdownItem v-on:click="$router.push({path:'/dashboard/settings/contacts'})">-->
<!--            <CIcon name="cil-user"/>-->
<!--            مخاطبین-->
<!--        </CDropdownItem>-->

        <CDropdownItem >
            <CIcon name="cil-lock-locked"/>
            {{$t('buttons.changePassword')}}
        </CDropdownItem>

        <CDropdownItem v-on:click="log_out">
            <CIcon name="cil-lock-locked"/>
            {{$t('buttons.logout')}}
        </CDropdownItem>
    </CDropdown>
</template>

<script>
    export default {
        name: 'TheHeaderDropdownAccnt',
        data() {
            return {
                itemsCount: 42,
                user_name: '',
            }
        }
        , mounted() {
            this.user_name = localStorage.getItem("user_name");
        },
        methods: {
            log_out() {
                localStorage.setItem("token", "");
                this.$router.push({path: "/pages/login"});
            }
        }
    }
</script>

<style scoped>
    .c-icon {
        margin-right: 0.3rem;
    }
</style>